<template>
    <div>
        <div class="d-flex flex-row align-items-start ">
            <img src="../../assets/images/person.svg" alt="" class="mr-3" style="width: 20px">
            <h5>Friends referred:</h5>
        </div>
    
        <div class="overflow-hidden">
            <button class="btn btn-link border float-right text-muted ml-2" v-if="hasNext" @click="loadNext"><i class="fa fa-chevron-right"></i></button>
            <button class="btn btn-link border float-right text-muted" v-if="hasPrev" @click="loadPrev"><i class="fa fa-chevron-left"></i></button>
        </div>
        <ul class="list-group my-3">
            <li class="list-group-item d-flex justify-content-around" v-for="(reward,key) in rewards" :key="key">
                <div class="border-right pr-2 pr-lg-3">{{ reward.created_at | dateFormat }}</div>
                <div class=" px-2 px-lg-3 flex-fill">{{ reward.referee.first_name }} {{ reward.referee.last_name }}
                </div>
                <div class="border-left pl-2 pl-lg-3">£{{ reward.amount }}</div>
            </li>
        </ul>
        <ul class="list-group my-3">
            <li class="list-group-item d-flex justify-content-around font-weight-bold">
                <div class="flex-fill">
                    Total rewards
                </div>
                <div class="border-left pl-2 pl-lg-3">£{{ totalRewards }}</div>
            </li>
        </ul>
        
    </div>
</template>

<script>
import api from "@/utils/api";
import {EventBus, events} from "@/utils/event-bus";

const moment = require('moment');
export default {
    name: "ReferralsList",
    data() {
        return {
            rewards: [],
            page: 1,
            totalRewards: 0,
            pagination: {
                next: null,
                prev: null
            }
        }
    },
    computed: {
        hasNext() {
            return !!this.pagination.next;
        },
        hasPrev() {
            return !!this.pagination.prev;
        },
    },
    methods: {
        loadNext() {
            this.loadData(++this.page)
        },
        loadPrev(){
            this.loadData(--this.page)
        },
        loadData(page){
            page = page || this.page
            let that = this;
            api.rewards(page).then(response => {
                that.rewards = response.data.data
                that.totalRewards = response.data.meta.total
                that.pagination = response.data.pagination
            })
        },
        handlePayoutRequest: function (){
            this.loadData()
        }
    },
    filters: {
        dateFormat: function (date) {
            return moment(date * 1000).format('DD/MM/YY')
        }
    },
    watch: {
        totalRewards: function (val) {
            this.$store.commit('auth/totalRewards', val)
        }
    },
    mounted() {
        this.loadData()
        EventBus.$on(events.rewards.payout, this.handlePayoutRequest)
    },
    destroyed() {
        EventBus.$off(events.rewards.payout)
    }
}
</script>

<style scoped>

</style>
